// 発送タブのヘッダ: 倉庫出荷（stoq-worker）連携の状態と「今すぐ同期」（第2弾）。
// 追跡番号は倉庫の出荷実績（毎日17時台に stoq-worker が取り込む）から gifting が30分おき（JST 17:00〜22:30）に同期する。
import type { GfTabProps } from "../../../../types/gifting";
import { fmtDateTime } from "../../../../lib/giftingRules";
import { GfButton, GfTag } from "../../ui/GfUi";
import { errMsg } from "../../gfUtil";
import { useGfShipStatus } from "../../useGfShipStatus";

export function ShipSyncBar({ data, refresh, toast }: Pick<GfTabProps, "data" | "refresh" | "toast">) {
  const { status, syncing, sync } = useGfShipStatus(data.board);

  const runSync = async () => {
    try {
      const r = await sync();
      await refresh();
      toast(
        r.errors.length > 0
          ? `同期しました（発送済みへ ${r.advanced}件・エラー ${r.errors.length}件）`
          : r.advanced > 0
            ? `${r.advanced}件の追跡番号を取り込み、発送済みにしました`
            : "新しい出荷実績はありませんでした"
      );
    } catch (e) {
      toast(`同期できませんでした: ${errMsg(e)}`);
    }
  };

  const s = status.status === "ok" ? status.data : null;
  return (
    <div className="gf-ship-conn">
      <span className={`gf-dot${status.status === "error" || s?.last_error ? " is-warn" : status.status === "ok" ? "" : " is-off"}`} />
      <span>倉庫出荷（stoq-worker）連携</span>
      {status.status === "loading" && <GfTag tone="muted">確認中</GfTag>}
      {status.status === "error" && <GfTag tone="warn">状態を取得できません</GfTag>}
      {s && (s.last_error ? <GfTag tone="warn">同期エラー</GfTag> : <GfTag tone="ok">接続済み</GfTag>)}
      {s && (
        <span className="gf-note">
          最終同期 {s.last_sync_at ? fmtDateTime(s.last_sync_at) : "未実行"}・追跡待ち {s.pending}件{s.failed > 0 ? `・送信失敗 ${s.failed}件（7日）` : ""}
        </span>
      )}
      <GfButton size="sm" disabled={syncing || status.status === "loading"} onClick={() => void runSync()}>
        {syncing ? "同期中…" : "今すぐ同期"}
      </GfButton>
      {s?.last_error && <span className="gf-note gf-warn-text">直近のエラー: {s.last_error}</span>}
    </div>
  );
}
